import { useCallback, useEffect, useMemo, useState } from 'react'
import { useAuth } from '../../core/contexts/AuthContext';
import { LoginRequest } from '../../core/types/LoginRequest.model';
import { LoginResult } from '../../core/types/LoginResult.model';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('')
  const [regId, setRegId] = useState('')
  const [eventName, setEventName] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const { login, isSilenceLogin } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const eventName = params.get("eventName");
    setEventName(eventName || '');
  }, []);

  const userToken = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const retVal = params.get("token");
    if (!retVal) setError('user token not exist')
    return retVal;
  }, []);



  const handleSubmit = async (e: { preventDefault: () => void; }) => {
    e.preventDefault()
    loginUser();

  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const parmEmail = params.get("email");
    const parmRegId = params.get("regId");

    if (parmEmail) setEmail(parmEmail);
    if (parmRegId) setRegId(parmRegId);
  }, []);

  const loginUser = useCallback(async () => {
    if (!userToken) return;
    setError('')
    setIsLoading(true)

    try {
      const user: LoginRequest = { email, regId, userToken };
      const result: LoginResult = await login(user, eventName, isSilenceLogin);
      if (!result.success) {
        setError(result.error || 'Invalid credentials')
      }
    } catch (err) {
      setError('An error occurred during login')
    } finally {
      setIsLoading(false)
    }
  }, [email, regId, userToken, eventName, login, isSilenceLogin]);

  useEffect(() => {
    isSilenceLogin && loginUser()
  }, [isSilenceLogin]);


  const showEventName = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const parmEventName = params.get("eventName");
    return parmEventName ? true : false;
  }, []);


  return (
    <>  {isSilenceLogin && !error ?
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center' }}>
        <div className="loader"></div>
        <span>Loading...</span>
      </div>
      :
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light py-5">
        <div className="w-100" style={{ maxWidth: '400px' }}>
          <div className="text-center mb-4">
            <p className="text-muted">
              Welcome to the 1:1 Meeting Scheduler – Your Personalised Exhibitor Meeting Tool!

              This platform allows you to easily schedule one-on-one meetings with exhibitors, maximising your time at the event.

              To log in, please use the credentials sent to you in your registration confirmation email.

              If you can’t find the email, please check the FAQ page on the event website for assistance
            </p>
          </div>

          <div className="card shadow-sm">
            <div className="card-body p-4">
              <form onSubmit={handleSubmit}>

               { !showEventName && <div className="mb-3">
                  <label htmlFor="eventName" className="form-label">
                    Event Name
                  </label>
                  <input
                    id="eventName"
                    name="eventName"
                    type="text"
                    className="form-control"
                    autoComplete="eventName"
                    required
                    placeholder="Event Name"
                    value={eventName ?? ''}
                    onChange={(e) => setEventName(e.target.value)}
                  />
                </div>}

                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email address
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    className="form-control"
                    autoComplete="email"
                    required
                    placeholder="Email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="registrationID" className="form-label">
                    Registration ID
                  </label>
                  <input
                    id="registrationID"
                    name="registrationID"
                    type="password"
                    className="form-control"
                    autoComplete="current-password"
                    required
                    placeholder="Registration ID"
                    value={regId}
                    onChange={(e) => setRegId(e.target.value)}
                  />
                </div>

                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isLoading}
                  className="btn btn-primary w-100"
                >
                  {isLoading ? 'Signing in...' : 'Sign in'}
                </button>
              </form>
            </div>
          </div>


        </div>
      </div>
    }
    </>
  )
}

export default Login 